import { forwardRef } from 'react';

export const LogoStar = forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<'svg'>
>(({ color = 'currentColor', ...props }, ref) => (
  <svg
    ref={ref}
    fill='none'
    viewBox='0 0 45 41'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22.5 2.687h.1l.01.201c.23 4.187 1.456 8.239 4.315 11.393.137.152.272.307.407.462a13.168 13.168 0 0 0 1.908 1.777c.093.073.186.146.28.222 3.177 2.472 6.789 3.374 10.722 3.758v.1l-.196.012c-2.914.185-5.652.737-8.229 2.177l-.312.17a16.275 16.275 0 0 0-3.402 2.569 47.11 47.11 0 0 1-.44.42c-3.38 3.28-4.866 7.844-5.064 12.465h-.297l-.011-.347c-.167-4.351-1.665-8.483-4.654-11.683a8.527 8.527 0 0 1-.395-.467c-.29-.362-.631-.641-.986-.938l-.158-.133a16.923 16.923 0 0 0-2.816-1.956l-.19-.105C10.446 21.347 7.647 20.74 4.66 20.6v-.1l.229-.02c4.832-.423 8.773-1.916 12.359-5.254l.177-.162c.608-.578 1.108-1.256 1.607-1.928l.127-.17C21.389 9.94 22.195 6.369 22.5 2.688Z'
      fill={color}
    />
  </svg>
));
